export const awsConfig = {
  dev: {
    Auth: {
      Cognito: {
        region: 'us-east-2',
        userPoolId: 'us-east-2_Sb7DbMDQi',
        userPoolClientId: '1f3k3h7ro4p8es37vm0753vkos',
        signUpVerificationMethod: 'code',
        loginWith: {
          email: true,
        },
        mfa: {
          totpEnabled: true,
          smsEnabled: true,
        },
      },
    },
  },
  staging: {
    Auth: {
      Cognito: {
        region: 'us-west-2',
        userPoolId: 'us-west-2_EDRJJr9Vo',
        userPoolClientId: '5mi3ipssv1el6kk64964khb7if',
        signUpVerificationMethod: 'code',
        loginWith: {
          email: true,
        },
        mfa: {
          totpEnabled: true,
          smsEnabled: true,
        },
      },
    },
  },
  uat: {
    Auth: {
      Cognito: {
        region: 'us-west-2',
        userPoolId: 'us-west-2_9Ap0rNOfy',
        userPoolClientId: '5ogq9a1pggm1l2rebp5l5rngd4',
        signUpVerificationMethod: 'code',
        loginWith: {
          email: true,
        },
        mfa: {
          totpEnabled: true,
          smsEnabled: true,
        },
      },
    },
  },
  production: {
    Auth: {
      Cognito: {
        region: 'us-west-2',
        userPoolId: 'us-west-2_7QPFbKVm2',
        userPoolClientId: '55tece4pmvi9ruqs2cahuh1jf7',
        signUpVerificationMethod: 'code',
        loginWith: {
          email: true,
        },
        mfa: {
          totpEnabled: true,
          smsEnabled: true,
        },
      },
    },
  },
  prod: {
    Auth: {
      Cognito: {
        region: 'us-west-2',
        userPoolId: 'us-west-2_7QPFbKVm2',
        userPoolClientId: '55tece4pmvi9ruqs2cahuh1jf7',
        signUpVerificationMethod: 'code',
        loginWith: {
          email: true,
        },
        mfa: {
          totpEnabled: true,
          smsEnabled: true,
        },
      },
    },
  },
};
